var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["children", "className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import classNames from "classnames";
import React from "react";
import { Button } from "@riseart/common";
import { artActionButtonCls, artActionButtonLinkCls } from "./Action.less";
var ArtActionEnquire = /* @__PURE__ */ __name(function ArtActionEnquire2(_ref) {
  var children = _ref.children, className = _ref.className, restProps = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React.createElement(Button, _extends({
    type: "secondary",
    size: "medium",
    width: "container",
    className: classNames(artActionButtonLinkCls, artActionButtonCls, className)
  }, restProps), children);
}, "ArtActionEnquire");
export {
  ArtActionEnquire
};
